import { Navigation } from 'swiper/modules';

let mouseTimer
const project = {
	swiper: null,

	init() {
		this.swiper = new Swiper('.swiper', {
			modules: [Navigation],
			loop: true,
			navigation: {
				nextEl: ".js-swiper-next",
				prevEl: ".js-swiper-prev",
			},
		});
		this.swiper.on('slideChange',
			this.handleSoundClick.bind(this)
		)
		this.initEvents();
	},

	initEvents() {
		jQuery(document).on('click', '.js-slider-slide-mini', this.handleSliderMiniClick.bind(this));

		jQuery(document).on('click', '.js-credits', this.handleCreditClick.bind(this));

		jQuery(document).on('click', '.js-button-sound', this.handleSoundMutedClick.bind(this));

		jQuery(document).on('click', '.js-button-full-screen', this.handleFullScreenClick.bind(this));

		jQuery(document).on('click', '.js-swiper-prev-mini, .js-swiper-next-mini', this.handleButtonMiniClick.bind(this));

		jQuery(document).on('click', '.js-swiper-next, .js-swiper-prev', this.handleSliderButtonClick.bind(this));

		if(window.innerWidth > 1024) {
			jQuery(document).on('mousemove', this.handleMouseMove.bind(this));
			jQuery(document).on('scroll', this.handleMouseMove.bind(this));
		}
	},

	handleFullScreenClick() {
		let media = document.querySelector('.swiper-slide-active')


		if (media.requestFullscreen) {
			media.requestFullscreen();
		} else if (media.webkitRequestFullscreen) {
			media.webkitRequestFullscreen();
		} else if (media.msRequestFullscreen) {
			media.msRequestFullscreen();
		}
	},

	handleButtonMiniClick(e) {
		if (e.currentTarget.classList.contains('js-swiper-next-mini')) {
			let bouton = document.querySelector('.js-swiper-next');
			bouton.click();
		}
		else{
			let bouton = document.querySelector('.js-swiper-prev');
			bouton.click();
		}
	},

	handleMouseStop() {
		let swiperPrev = document.querySelector('.js-swiper-prev');
		swiperPrev.classList.add('js-mouse-move');
		let swiperNext = document.querySelector('.js-swiper-next');
		swiperNext.classList.add('js-mouse-move');
		let footer = document.querySelector('.project__hero-footer');
		footer.classList.add('js-mouse-move');
	},

	handleMouseMove() {
		let swiperPrev = document.querySelector('.js-swiper-prev');
		swiperPrev.classList.remove('js-mouse-move');
		let swiperNext = document.querySelector('.js-swiper-next');
		swiperNext.classList.remove('js-mouse-move');
		let footer = document.querySelector('.project__hero-footer');
		footer.classList.remove('js-mouse-move');
		clearTimeout(mouseTimer);
		// mouseTimer = setTimeout(this.handleMouseStop.bind(this), 2000);
	},

	handleSliderMiniClick(e) {
		let swiper = document.querySelector('.swiper');
		let wrapper = Array.from(swiper.childNodes).find(node => {
			return node.classList && node.classList.contains('swiper-wrapper');
		});
		const index = jQuery(e.currentTarget).data('index');
		this.swiper.slideToLoop(index);
		Array.from(wrapper.children).forEach((video) => {
			if(video.tagName === 'VIDEO'){
				video.pause();
			}
		})
	},

	handleSliderButtonClick(e) {
		let swiper = document.querySelector('.swiper');
		let wrapper = Array.from(swiper.childNodes).find(node => {
			return node.classList && node.classList.contains('swiper-wrapper');
		});

		Array.from(wrapper.children).forEach((video) => {
			if(video.tagName === 'VIDEO'){
				video.muted = true;
			}
		})
	},

	handleCreditClick() {
		jQuery('html, body').animate({
			scrollTop: jQuery('.js-content').offset().top
		}, 1000);
	},

	handleSoundClick(swiper) {
		let divButton =  document.querySelector('.project__sounds');
		let soundOn = Array.from(divButton.childNodes).find(node => {
			return node.classList && node.classList.contains('project__sound-on');
		})

		let media = swiper.slides[swiper.activeIndex];

		if(media.tagName === 'VIDEO'){
			media.currentTime = 0;
			media.play();
			media.muted = soundOn.classList.contains('project--transparent');
		}
		if(media.tagName === 'IMG'){
			divButton.classList.add('project--transparent');
		}
		else{
			divButton.classList.remove('project--transparent');
		}
	},

	handleSoundMutedClick(e) {
		let divButton =  document.querySelector('.project__sounds');
		let soundOn = Array.from(divButton.childNodes).find(node => {
			return node.classList && node.classList.contains('project__sound-on');
		});

		let soundOff = Array.from(divButton.childNodes).find(node => {
			return node.classList && node.classList.contains('project__sound-off');
		});

		let video = jQuery('.swiper-slide-active');

		if (video.prop('muted') === true ) {
			video.prop('muted', false);
			soundOn.classList.remove('project--transparent');
			soundOff.classList.add('project--transparent');
		} else {
			video.prop('muted', true);
			soundOn.classList.add('project--transparent');
			soundOff.classList.remove('project--transparent');
		}
	},
}

project.init();
